/** SaaS plan tiers and feature gates (mirrors backend/entitlements.py). */

export const PLANS = ["solo", "practice", "clinic"]
export const PLAN_ORDER = { solo: 1, practice: 2, clinic: 3 }

export const FEATURE_MIN_PLAN = {
  clients: "solo",
  appointments: "solo",
  notes_basic: "solo",
  telehealth: "solo",
  billing: "solo",
  segments: "practice",
  waitlist: "practice",
  care_plans: "practice",
  hr: "practice",
  cnas: "practice",
  team_invites: "practice",
  analytics_basic: "practice",
  patient_360: "practice",
  communications: "practice",
  referrals: "practice",
  portal_partial: "practice",
  care_plan_templates_org: "clinic",
  portal_full: "clinic",
  multi_location: "clinic",
  workflows: "clinic",
  analytics_advanced: "clinic",
  audit_export: "clinic",
  scheduling_resources: "clinic",
  queues: "clinic",
  whatsapp: "clinic",
}

export const ADDON_FEATURES = {
  ehr_connector: ["ehr_sync"],
  adt_and_beds: ["adt"],
  marketing_suite: ["campaigns"],
  predictive_ai: ["predictive_analytics"],
}

export const ADDON_LABELS = {
  ehr_connector: "EHR Connector",
  adt_and_beds: "ADT & Paturi",
  marketing_suite: "Marketing Suite",
  predictive_ai: "Predictive AI",
}

export function addonForFeature(feature) {
  for (const [addonId, feats] of Object.entries(ADDON_FEATURES)) {
    if (feats.includes(feature)) return addonId
  }
  return null
}

export const NAV_FEATURES = {
  "/app": "clients",
  "/app/clients": "clients",
  "/app/appointments": "appointments",
  "/app/notes": "notes_basic",
  "/app/care-plans": "care_plans",
  "/app/care-plan-templates": "care_plans",
  "/app/billing": "billing",
  "/app/hr": "hr",
  "/app/waitlist": "waitlist",
  "/app/analytics": "analytics_basic",
  "/app/communications": "communications",
  "/app/referrals": "referrals",
  "/app/scheduling/resources": "scheduling_resources",
  "/app/queues": "queues",
  "/app/workflows": "workflows",
  "/app/network": "multi_location",
  "/app/adt": "adt",
  "/app/campaigns": "campaigns",
  "/app/integrations": "clients",
  "/app/settings": "clients",
}

export function planMeets(required, actual) {
  return (PLAN_ORDER[actual] || 0) >= (PLAN_ORDER[required] || 0)
}

export function hasFeature(user, feature) {
  if (!user) return false
  const plan = user.effective_plan || user.subscription_plan || "solo"
  const features = user.features || []
  if (features.includes(feature)) return true
  const min = FEATURE_MIN_PLAN[feature]
  if (min && planMeets(min, plan)) return true
  return false
}

export function minPlanFor(feature) {
  return FEATURE_MIN_PLAN[feature] || "practice"
}

export function canAccessRoute(user, path) {
  const base = path.replace(/\/app\/patients\/[^/]+/, "/app/clients")
  const feat = NAV_FEATURES[base] || NAV_FEATURES[path.split("/").slice(0, 3).join("/")]
  if (!feat) return true
  return hasFeature(user, feat)
}
